import { makeStyles } from '@material-ui/core/styles';

export const useListTobaccoProductsStyles = makeStyles(theme => ({
  products: {
    display: 'flex',
    flexWrap: 'wrap'
  }
}));
